import { Box, IconButton, Paper, Stack, useTheme } from "@mui/material";
import { CartButton } from "./cart-button.js";
import { LocalizationContext } from "../localization/index.js";
import { Logo } from "../logo/index.js";
import { Menu } from "@mui/icons-material";
import { MobileMenu } from "./mobile-menu.js";
import { useScrollDirection } from "../utilities/index.js";
import { useTranslation } from "next-i18next";
import { useWindowScrollPosition } from "rooks";
import Link from "next/link";
import React from "react";
export const MobileStickyHeader = ({ bgColor = "white", items = [], }) => {
    const { mode } = React.useContext(LocalizationContext);
    const { t } = useTranslation("c-common");
    const theme = useTheme();
    const [showNavigation, setShowNavigation] = React.useState(false);
    const toggleNavigation = () => setShowNavigation((current) => !current);
    const scrollDirection = useScrollDirection(50);
    const { scrollY } = useWindowScrollPosition();
    const show = scrollDirection === "up" && scrollY >= 900;
    return (React.createElement(React.Fragment, null,
        React.createElement(Paper, { id: "mobile-sticky-header", elevation: 0, sx: {
                backgroundColor: "white",
                borderBottom: `1px solid ${theme.palette.divider}`,
                borderRadius: 0,
                left: 0,
                opacity: show ? 1 : 0,
                position: "fixed",
                top: 0,
                transform: `translateY(${show ? "0" : "-100%"})`,
                transition: theme.transitions.create(["transform", "opacity"]),
                width: "100%",
                zIndex: 60,
            } },
            React.createElement(Stack, { alignItems: "center", direction: "row", justifyContent: "space-between", spacing: 3, sx: { px: 2, py: 1, width: "100%" } },
                React.createElement(Box, { sx: { width: "45px" } }, mode === "store" && React.createElement(CartButton, { color: theme.palette.text.primary, size: "small" })),
                React.createElement(Box, { sx: {
                        flex: 1,
                        svg: {
                            maxWidth: { xs: "90%", sm: "260px" },
                            display: "block",
                            margin: "0 auto",
                        },
                    } },
                    React.createElement(Link, { "aria-label": "Startseite", href: "/", title: t("seo-site-title") },
                        React.createElement(Logo, { fill: theme.palette.text.primary, variant: "text", title: t("seo-site-title") }))),
                React.createElement(Box, { sx: { width: "45px" } },
                    React.createElement(IconButton, { "aria-label": "Hauptmen\u00FC \u00F6ffnen", name: "Hauptmen\u00FC \u00F6ffnen", onClick: toggleNavigation, size: "small", sx: { color: theme.palette.text.primary } },
                        React.createElement(Menu, { fontSize: "small" }))))),
        React.createElement(MobileMenu, { handleClose: toggleNavigation, items: items, show: showNavigation })));
};
//# sourceMappingURL=mobile-sticky.js.map